import EmailTemplateType from './EmailTemplateType';

export default class EmailTemplateTypeViewModel {
    name: string;
    value: EmailTemplateType;

    public constructor(name: string, value: EmailTemplateType) {
        this.name = name;
        this.value = value;
    }
}